export default "../../src/img/lysiq-symbol-3d-2.jpg";